import { useEffect, useMemo, useState } from "react";

export function useDayViewSelection(sortedEvents, initialSelectedEventId) {
  const [selectedEventId, setSelectedEventId] = useState(
    () => initialSelectedEventId ?? sortedEvents[0]?.id ?? null,
  );

  const selectedEvent = useMemo(
    () => sortedEvents.find((event) => event.id === selectedEventId) || null,
    [selectedEventId, sortedEvents],
  );

  useEffect(() => {
    if (sortedEvents.length === 0) {
      setSelectedEventId(null);
      return;
    }

    const hasSelectedEvent = sortedEvents.some((event) => event.id === selectedEventId);
    if (!hasSelectedEvent) {
      setSelectedEventId(sortedEvents[0].id);
    }
  }, [selectedEventId, sortedEvents]);

  return { selectedEventId, setSelectedEventId, selectedEvent };
}
